import * as Yup from "yup";
import { Persolog_ClassType } from "@relay/persologClassForm_PersologClassFragment.graphql";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createPersologElementQuestionClassFormSchema = (t: TFunc) =>
	Yup.object().shape({
		text: Yup.string().required(t("validation:textFieldRequired")),
		classType: Yup.mixed<Persolog_ClassType>()
			.oneOf(["D", "G", "I", "S"], t("validation:invalidClassType"))
			.required(t("validation:typeRequired")),
	});
